<template>
    <div class="recipeSingle page" @scroll="pageScroll" ref="page">
        
        <transition-group name="fade">
            <div
                style="animation-duration: 0.3s"
                v-if="( currentRecipe.id != $route.query.recipe )"
                :key="1"
                class="preloader"
            >
                <img :src="getStaticImage('logo.png')" alt="">
                <Loader></Loader>
            </div>
            <div
                style="animation-duration: 0.3s"
                v-else
                :key="2"
                class="recipeContainer"
                id="printMe"
            >
                <div class="pageContainer">
                    <div class="container">
                        <h2 class="d-flex">
                            <span class="backButton"><img :src="getStaticImage('icon-arrow-left.png')" @click="$router.go(-1)"
                                       alt="back"></span>
                            <span class="text-center flex-grow-1" v-if="getLng() == 'en'">{{currentRecipe.title}} Recipe</span>
                            <span class="text-center flex-grow-1" v-else>{{currentRecipe.title}} Receta</span>
                            

                            <span style="width: 35px;"></span>
                        </h2>
                        
                        <div class="actions d-flex align-items-center mt-4 mb-3 ">
                            
                            <LikeButton :recipe_id="currentRecipe.id" :recipe="currentRecipe"></LikeButton>
                            
                            <span class="ml-auto" @click="shareThis( {title: currentRecipe.title, text: '', url: href} )"><img width="24" :src="getStaticImage('icon-share.png')"></span>
                            <span @click="print" class="ml-3"><img width="22" :src="getStaticImage('icon-print.png')"></span>
                        </div>
                        
                        <div class="text-center">
                            <div class="imgBox">
                                <img class="img-fluid mainImg" :src="currentRecipe.image ? currentRecipe.image : getStaticImage('logo.png')">
                            </div>
                        </div>
                        
                        <div class="text-center smallText mt-2 mb-5">{{currentRecipe.title}}</div>
                        
                        <div class="singleDetails"  v-if="currentRecipe.ingredients">
                            <h2 v-if="getLng() == 'en'">Ingredients</h2>
                            <h2 v-else>Ingredientes</h2>
                            <ul>
                                <li v-for="ingredient in currentRecipe.ingredients" > <v-runtime-template :template="ingredient"></v-runtime-template>  </li>
                            </ul>
                            
                        </div>
                        <div class="singleDetails" v-if=" ( currentRecipe.serving_size || currentRecipe.techniques || currentRecipe.garnish || currentRecipe.glass ) ">
                            <h2 v-if="getLng() == 'en'">Details</h2>
                            <h2 v-else>Detalles</h2>
                            <ul>
                                <li v-if="currentRecipe.serving_size">
                                    Serves: {{currentRecipe.serving_size}}
                                </li>
                                
                                <li v-if="currentRecipe.techniques">
                                    Technique: {{ currentRecipe.techniques }}
                                </li>
                                
                                <li v-if="currentRecipe.garnish">
                                    Garnish: {{ currentRecipe.garnish }}
                                </li>
                                
                                <li v-if="currentRecipe.glass">
                                    Glass: {{currentRecipe.glass}}
                                </li>
                            </ul>
                        </div>
                        
                        <div class="singleDetails" v-if="currentRecipe.directions">
                            <h2 v-if="getLng() == 'en'">Directions</h2>
                            <h2 v-else>Direcciones</h2>
                            <ul>
                                <li v-for=" direction in currentRecipe.directions">
                                    {{direction}}
                                </li>
                            </ul>
                        </div>
                        
                        <pre>
                    </pre>
                    </div>
                </div>
            </div>
        </transition-group>
    
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import shareMixin from "../mixins/share"
    import pageMixin from "../mixins/page";
    import LikeButton from "./LikeButton"
    import VRuntimeTemplate from "v-runtime-template";
    import Loader from "./Loader";
    

    export default {
        name: "RecipesSingle",
        components: {LikeButton, VRuntimeTemplate, Loader},
        mixins:[shareMixin, pageMixin],
        computed: {
            ...mapState("recipe", ["currentRecipe"])
        },
        data(){
            return {
                href: window.location.href
            }
        },
        methods: {
            print() {
                if (window.cordova){
                    const page = document.getElementById('printMe');
                    const style = "<style>@media print {.actions, .backButton, .bottomMenu, pre, header>*:not(.logo) {display: none !important;}}</style>"
                    window.cordova.plugins.printer.print(page.innerHTML.replace(/http/g,"https") + style);
                }else{
                    window.print();
                }
                
            },
            getLng() {
                return localStorage.getItem( 'lng' ) || 'en';
            }

        },
        created() {
            if (this.currentRecipe.id !== this.$route.query.recipe) {
                this.$store.dispatch("recipe/getCurrent", this.$route.query.recipe);
            }
        },
        updated(){
            if (this.currentRecipe.id !== this.$route.query.recipe) {
                this.$store.dispatch("recipe/getCurrent", this.$route.query.recipe);
            }
        },
        watch:{
            currentRecipe(){
                this.changePageTitle(this.currentRecipe.title + " Cocktail Recipe | ABM Cocktail Pro");
            }
        }
        /*computed: {
            transformed(ingredient) {
                return {
                    template: ingredient,
                    props: this.$options.props
                }
            }
        }*/
    }
</script>

